import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";

import { FieldShell } from "./FieldShell";
import {
  buildFieldIds,
  getNestedError,
  hasNonEmptyDescription,
  type SchemaFieldProps,
} from "./utils";

export function NumberField({
  fieldKey,
  property,
  fieldPath,
  isRequired,
  control,
  errors,
}: SchemaFieldProps) {
  const errorMessage = getNestedError(errors, fieldPath);
  const { describedBy } = buildFieldIds(fieldPath, hasNonEmptyDescription(property.description));
  const isInteger = property.type === "integer";

  return (
    <FieldShell
      fieldKey={fieldKey}
      descriptionId={describedBy}
      isRequired={isRequired}
      description={property.description}
    >
      <Controller
        name={fieldPath}
        control={control}
        rules={{
          ...(isRequired ? { required: "This field is required" } : {}),
          validate: {
            isNumber: (value: unknown) => {
              if (value === "" || value === undefined || value === null) {
                return true;
              }

              const parsed = Number(value);
              if (Number.isNaN(parsed)) {
                return "Must be a valid number";
              }
              if (isInteger && !Number.isInteger(parsed)) {
                return "Must be a whole number";
              }
              return true;
            },
          },
        }}
        defaultValue=""
        render={({ field }) => (
          <TextField
            name={field.name}
            inputRef={field.ref}
            label={fieldKey}
            required={isRequired}
            type="number"
            size="small"
            value={field.value ?? ""}
            error={Boolean(errorMessage)}
            helperText={errorMessage}
            inputProps={{ "aria-describedby": describedBy, step: isInteger ? 1 : "any" }}
            sx={{ width: 300 }}
            onBlur={field.onBlur}
            onChange={(event) => {
              const { value } = event.target;
              field.onChange(value === "" ? "" : Number(value));
            }}
          />
        )}
      />
    </FieldShell>
  );
}
